import React, { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

// ✅ Import PDFs from assets folder

import admissionForm from '../assets/Admisson Form 2025-26.pdf';
import admissionNotice from '../assets/प्रवेश सूचना (2025-2026).pdf';
import introGuide from '../assets/परिचायिका (2025-26) (18-06-25).pdf';

// ✅ Departments with proper PDF URLs
const departments = [
    {
        id: "ad",
        name: "प्रवेश विज्ञापन",
        content: "यह प्रवेश विज्ञापन की जानकारी है।",
        pdfFiles: [
            { name: "प्रवेश सूचना (2025-26)", url: admissionNotice }
        ]
    },
    {
        id: "rulebook",
        name: "परिचय नियमावली",
        content: "यह परिचय नियमावली है।",
        pdfFiles: [
            { name: "परिचायिका (2025-26)", url: introGuide }
        ]
    },
    {
        id: "policy",
        name: "प्रवेश नीति",
        content: "यह प्रवेश नीति है।",
        pdfFiles: []
    },
    {
        id: "committee",
        name: "प्रवेश समिति",
        content: "यह प्रवेश समिति की जानकारी है।",
        pdfFiles: []
    },
    {
        id: "portal",
        name: "प्रवेश पोर्टल",
        content: "यह प्रवेश पोर्टल है।",
        pdfFiles: []
    },
    {
        id: "applicationForm",
        name: "प्रवेश आवेदन पत्र",
        content: "यह प्रवेश आवेदन पत्र है।",
        pdfFiles: [
            { name: "आवेदन पत्र (सत्र 2025-26)", url: admissionForm }
        ]
    }
];

export default function Entry() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [activeContentId, setActiveContentId] = useState(departments[0].id);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) {
                setShowSidebar(true);
            } else {
                setShowSidebar(false);
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleItemClick = (deptId) => {
        setActiveContentId(deptId);
        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };

    const selectedDepartment = departments.find((dept) => dept.id === activeContentId);

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">

            {/* Toggle Button for Small Screens */}
            <button
                className="btn d-md-none m-2 shadow-sm text-white"
                onClick={() => setShowSidebar(!showSidebar)}
                style={{
                    backgroundColor: "#77236b",
                    borderColor: "#77236b"
                }}
            >
                ☰ मेनू
            </button>

            {/* Sidebar */}
            <aside
                className={`p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none d-md-flex"} col-md-3`}
                style={{ backgroundColor: '#f8f9fa', overflowY: 'auto' }}
            >
                <h5 className="text-center fw-bold mb-3 text-dark">प्रवेश</h5>
                <div className="flex-grow-1">
                    {departments.map((dept) => {
                        const isActive = activeContentId === dept.id;
                        return (
                            <p
                                key={dept.id}
                                className={`mb-2 p-2 rounded shadow-sm small ${isActive ? 'text-white fw-bold' : 'text-dark bg-white'}`}
                                style={{
                                    cursor: "pointer",
                                    backgroundColor: isActive ? "#77236b" : "#ffffff"
                                }}
                                onClick={() => handleItemClick(dept.id)}
                            >
                                {dept.name}
                            </p>
                        );
                    })}
                </div>
            </aside>

            {/* Main Content */}
            <main
                className="flex-grow-1 p-3 bg-white shadow col-md-9 overflow-auto"
                onClick={() => {
                    if (window.innerWidth < 768 && showSidebar) {
                        setShowSidebar(false);
                    }
                }}
            >

                <h5 className="fw-bold mb-3" style={{ color: "#77236b" }}>
                    {selectedDepartment?.name}
                </h5>





                {selectedDepartment?.pdfFiles?.length > 0 ? (
                    <div className="table-responsive">
                        <table className="table table-bordered mt-3">
                            <thead className="table-light">
                                <tr>
                                    <th>शीर्षक</th>
                                    <th>डाउनलोड</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedDepartment.pdfFiles.map((file, idx) => (
                                    <tr key={idx}>
                                        <td>{file.name}</td>
                                        <td>
                                            <a
                                                href={file.url}
                                                className="btn btn-sm btn-primary"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                download
                                            >
                                                डाउनलोड करें
                                            </a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <p className="text-muted">कोई PDF उपलब्ध नहीं है।</p>
                )}
            </main>
        </div>
    );
}
